import { Flex, Form } from 'antd';
import styles from './forgot-password-form.module.scss';
import TextField from '../form/text-field/text-field';
import Label from '../form/label/label';
import { Button } from '../button/button';
import { useTranslation } from 'react-i18next';

export type ForgotPasswordFieldType = {
  email: string;
};

interface ForgotPasswordFormProps {
  onSubmit: (value: ForgotPasswordFieldType) => void;
  error?: string;
  isLoading?: boolean;
}

export function ForgotPasswordForm({ onSubmit, error, isLoading }: ForgotPasswordFormProps) {
  const { t } = useTranslation(['auth', 'common']);
  const [form] = Form.useForm();
  return (
    <Flex className={styles.container} vertical gap={24}>
      <h3 className={styles.title}>{t('auth:forgotPassword.title')}</h3>
      <p className={styles.paragraph}>{t('auth:forgotPassword.description')}</p>
      <Form form={form} onFinish={onSubmit} autoComplete="off">
        <Label text={t('auth:fields.email')} />
        <Form.Item<ForgotPasswordFieldType>
          name="email"
          rules={[
            { required: true, message: t('common:validation.emailRequired') },
            { type: 'email', message: t('common:validation.emailInvalid') },
          ]}
        >
          <TextField
            autoComplete="email"
            onPaste={(e) => {
              const pastedValue = e.clipboardData.getData('Text');
              form.setFieldsValue({ email: pastedValue.trim() });
              e.preventDefault();
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" loading={isLoading} block>
            {t('auth:forgotPassword.submit')}
          </Button>
        </Form.Item>
        {error && <p>{error}</p>}
      </Form>
    </Flex>
  );
}
